if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
      const observer = new MutationObserver((MutationList) => {
        for (let item of MutationList) {
          if (item.target.classList?.contains('b2b-nt-modal-overlay')) {
            const time = document.querySelector(".b2b-nt-modal-content p strong");

            if (time && time.textContent.trim() === "in 30 days") {
                time.textContent = "30 dager";
            }
          }
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }, 300);
  }

function initCustomSaleBadges() {
  const productCards = document.querySelectorAll('.product-card');

  productCards.forEach(card => {
    card.querySelector('.custom-sale-badge')?.remove();
    if (card.querySelector('.custom-sale-badge.bss')) return;
    

    const imgWrapper = card.querySelector('.product-card__image-wrapper');
    if (!imgWrapper) return;

    const priceSpans = card.querySelectorAll('.f-price span, .product-price span');
    let originalPrice = 0;
    let salePrice = 0;

    priceSpans.forEach(span => {
      if (span.style.textDecoration === 'line-through' || span.style.textDecorationLine === 'line-through') {
        originalPrice = parseFloat(span.innerText.replace(/[^0-9,.]/g, '').replace(',', '.'));
      } else if (span.style.color === 'rgb(229, 28, 0)' || span.style.color === '#E51C00' || card.querySelector('.f-price--left span:last-child')) {
        if (span.style.color === 'rgb(229, 28, 0)' || span.style.color === '#E51C00' || span.innerText.includes('kr')) {
           if (!span.style.textDecoration.includes('line-through')) {
              salePrice = parseFloat(span.innerText.replace(/[^0-9,.]/g, '').replace(',', '.'));
           }
        }
      }
    });

    if (priceSpans.length >= 2 && (originalPrice === 0 || salePrice === 0)) {
        let prices = [];
        priceSpans.forEach(span => {
            let p = parseFloat(span.innerText.replace(/[^0-9,.]/g, '').replace(',', '.'));
            if (p > 0) prices.push(p);
        });
        if (prices.length >= 2) {
            originalPrice = Math.max(...prices);
            salePrice = Math.min(...prices);
        }
    }

    if (originalPrice > 0 && salePrice > 0 && originalPrice > salePrice) {
      const discountPercentage = Math.round(((originalPrice - salePrice) / originalPrice) * 100);

      if (discountPercentage > 0) {
        const badge = document.createElement('div');
        badge.className = 'custom-sale-badge bss';
        badge.innerText = `-${discountPercentage}%`;
        console.log('discountPercentage', discountPercentage)
        imgWrapper.appendChild(badge);
      }
    }
  });
}

let counter = 0;
let selector = '.f-price[bss-b2b-collection-element] span[style="text-decoration: line-through; margin-right: 10px; color: #303030;"]'
const interval = setInterval(() => {
    let element = document.querySelector(selector);
    if (element) {
        console.log("Phần tử đã xuất hiện");
        clearInterval(interval);
        initCustomSaleBadges()
    } else {
        counter += 100;
        if (counter >= 10000) {
            clearInterval(interval);
        }
    }
}, 100); 

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {

        const observer = new MutationObserver((MutationList) => {
            for (let item of MutationList) {
                if (item.target.classList.contains("f-cart-drawer__items")) {
                    setTimeout(() => {
                      BSS_B2B.nt.initFunction();
                      document.dispatchEvent(new Event("DOMContentLoaded"));
                    }, 300);
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }, 300); 
}
